import React, { useState, useEffect, useMemo } from "react";
import MaterialTable from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import { RequiredServiceDocumentRule } from "../../../models";
import { RequiredServiceDocumentRulesService } from "../../../services/ClientService";

export default function RequiredServiceDocumentRules() {
    const never = "never" as const;

    const [allData, setAllData] = useState([] as RequiredServiceDocumentRule[]);

    const [searchCounty, setSearchCounty] = useState("");
    const [searchCaseNumber, setSearchCaseNumber] = useState("");
    const [searchCaseType, setSearchCaseType] = useState("");

    const refreshData = () => {
        RequiredServiceDocumentRulesService.getList({}).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    setAllData(resp.data);
                } else {
                    //TODO: Show error
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    useEffect(() => {
        refreshData();
    }, []);

    const filteredData = useMemo(() => {
        if (!searchCounty && !searchCaseNumber && !searchCaseType) {
            return allData;
        }
        return allData.filter((rule) => {
            const countyMatch =
                !rule.county ||
                (searchCounty &&
                    searchCounty
                        .toLowerCase()
                        .includes(rule.county.toLowerCase()));
            const caseNumberMatch =
                !rule.containedInCaseNumber ||
                (searchCaseNumber &&
                    searchCaseNumber
                        .toLowerCase()
                        .includes(rule.containedInCaseNumber.toLowerCase()));
            const caseTypeMatch =
                !rule.caseType ||
                (searchCaseType &&
                    searchCaseType
                        .toLowerCase()
                        .includes(rule.caseType.toLowerCase()));
            return countyMatch && caseNumberMatch && caseTypeMatch;
        });
    }, [allData, searchCounty, searchCaseNumber, searchCaseType]);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Rules</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Rules
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-2">
                    <div className="col-sm-4">
                        <label className="form-label">County</label>
                        <input
                            type="text"
                            className="form-control"
                            value={searchCounty}
                            onChange={(e) => setSearchCounty(e.target.value)}
                            placeholder="Enter county name..."
                        />
                    </div>
                    <div className="col-sm-4">
                        <label className="form-label">Case Number</label>
                        <input
                            type="text"
                            className="form-control"
                            value={searchCaseNumber}
                            onChange={(e) =>
                                setSearchCaseNumber(e.target.value)
                            }
                            placeholder="Enter case number..."
                        />
                    </div>
                    <div className="col-sm-4">
                        <label className="form-label">Case Type</label>
                        <input
                            type="text"
                            className="form-control"
                            value={searchCaseType}
                            onChange={(e) => setSearchCaseType(e.target.value)}
                            placeholder="Enter case type..."
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%", zIndex: 20 }}>
                            <MaterialTable
                                options={{
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                                columns={[
                                    {
                                        title: "ID",
                                        field: "id",
                                        editable: never,
                                    },
                                    { title: "County", field: "county" },
                                    {
                                        title: "Case Type",
                                        field: "caseType",
                                    },
                                    { title: "Name", field: "name" },
                                    {
                                        title: "Contained In Case Number",
                                        field: "containedInCaseNumber",
                                    },
                                    {
                                        title: "Contained In Filename",
                                        field: "containedInFilename",
                                    },
                                    {
                                        title: "Active",
                                        field: "active",
                                        type: "boolean" as const,
                                    },
                                ]}
                                data={filteredData}
                                title="Required Service Document Rules"
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            RequiredServiceDocumentRulesService.add(
                                                {
                                                    body: {
                                                        ...newData,
                                                        active: true,
                                                    },
                                                }
                                            ).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                    onRowUpdate: (newData, oldData) =>
                                        new Promise((resolve, reject) => {
                                            RequiredServiceDocumentRulesService.update(
                                                {
                                                    id: oldData?.id ?? "",
                                                    body: newData,
                                                }
                                            ).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                    onRowDelete: (oldData) =>
                                        new Promise((resolve, reject) => {
                                            RequiredServiceDocumentRulesService.delete(
                                                {
                                                    id: oldData.id ?? "",
                                                }
                                            ).then(
                                                (resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
